import { ViewModel } from './model';
import html from './template.html';
import './style.less';

ko.components.register('import-poll-dialog', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      let element = componentInfo.element;
      element.classList.add('import-poll-dialog');

      return new ViewModel(params, element);
    },
  },
  template: html,
});
